<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1950"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1954"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1964"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1962" /></clipPath></defs><g
     id="g1956"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1958"><g
         id="g1960"
         clip-path="url(#clipPath1964)"><g
           id="g1966"
           transform="translate(297.4849,148.0718)"><path
             d="m 0,0 24.514,64.363 c 0.501,1.224 2.234,1.226 2.737,0.003 L 51.542,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1968" /></g><g
           id="g1970"
           transform="translate(305.1299,164.1016)"><path
             d="M 0,0 H 36.375"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1972" /></g><g
           id="g1974"
           transform="translate(191.8711,213.354)"><path
             d="m 0,0 v -65.228 c 0.721,-0.123 22.86,0 22.86,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1976" /></g><g
           id="g1978"
           transform="translate(462.1895,213.0562)"><path
             d="M 0,0 H -27.256 V -64.687 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1980" /></g><g
           id="g1982"
           transform="translate(460.1797,180.7129)"><path
             d="M 0,0 H -25.247"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1984" /></g><g
           id="g1986"
           transform="translate(270.0659,213.0562)"><path
             d="M 0,0 H -27.256 V -64.687 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1988" /></g><g
           id="g1990"
           transform="translate(268.0562,180.7129)"><path
             d="M 0,0 H -25.247"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1992" /></g><g
           id="g1994"
           transform="translate(360.8647,213.354)"><path
             d="m 0,0 22.32,-64.302 c 0.468,-1.317 2.334,-1.304 2.784,0.019 L 46.419,-0.12"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1996" /></g><g
           id="g1998"
           transform="translate(111.7095,103.6934)"><path
             d="m 0,0 h 368.742 c 13.282,0 24.049,10.767 24.049,24.048 v 104.21 c 0,13.282 -10.767,24.049 -24.049,24.049 H 56.113 c -13.281,0 -24.048,-10.767 -24.048,-24.049 V 32.065 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2000" /></g><g
           id="g2002"
           transform="translate(231.9517,103.6958)"><path
             d="m 0,0 v -0.002 c 0,-17.709 -14.356,-32.065 -32.064,-32.065 h -160.323 c -17.709,0 -32.065,14.356 -32.065,32.065 v 304.613 c 0,17.708 14.356,32.064 32.065,32.064 H -32.064 C -14.356,336.675 0,322.319 0,304.611 V 184.369"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2004" /></g><g
           id="g2006"
           transform="translate(119.7261,344.1772)"><path
             d="m 0,0 v 0 c -13.282,0 -24.049,10.767 -24.049,24.048 v 16.033 c 0,4.427 3.59,8.016 8.016,8.016 h 32.065 c 4.427,0 8.016,-3.589 8.016,-8.016 V 24.048 C 24.048,10.767 13.281,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2008" /></g><g
           id="g2010"
           transform="translate(167.8228,256)"><path
             d="m 0,0 v 24.048 c 0,22.136 -17.945,40.081 -40.081,40.081 h -16.032 c -22.136,0 -40.081,-17.945 -40.081,-40.081 V -8.016"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2012" /></g><g
           id="g2014"
           transform="translate(7.5,247.9839)"><path
             d="M 0,0 H 104.209"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2016" /></g><g
           id="g2018"
           transform="translate(47.5806,191.8711)"><path
             d="M 0,0 H 64.129"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2020" /></g><g
           id="g2022"
           transform="translate(47.5806,159.8066)"><path
             d="M 0,0 H 64.129"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2024" /></g><g
           id="g2026"
           transform="translate(47.5806,127.7417)"><path
             d="M 0,0 H 40.081"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2028" /></g></g></g></g></svg>
</template>
